<h1>{{ title }}</h1>
<!-- filtres -->
<acces-search-filters [showFiltreTarifNegatif]="true" (onApplyFilters)="applySearchCriteria($event)" [user]="user"></acces-search-filters>

<!-- piles des acces  -->
<acces-liste [refreshCommands]="reloadAccesPlanifieCommands" [user]="user" (accesClicked)="onAccesClicked($event)" [etat]="accesEtat.PLANIFIE"
	[title]="'Accès Planifié'" [foldedPannel]="false" (accesActionRequest)="onActionRequest($event)"></acces-liste>

<acces-liste 
	[refreshCommands]="reloadAccesDemandesCommands" [user]="user" (accesClicked)="onAccesClicked($event)" [etat]="accesEtat.ENREGISTRE"
	[title]="'Accès En attente de validation'" [highlightable]="true" (accesActionRequest)="onActionRequest($event)"></acces-liste>

<acces-liste [refreshCommands]="reloadAccesEnCoursCommands" [user]="user" (accesClicked)="onAccesClicked($event)" [etat]="accesEtat.EN_COURS" 
	[title]="'Accès en cours'" [pageSize]="20" (accesActionRequest)="onActionRequest($event)"></acces-liste>

<acces-liste [refreshCommands]="reloadAccesDemandeFermetureCommands" [user]="user" [highlightable]="true" (accesClicked)="onAccesClicked($event)" [etat]="accesEtat.ATTENTE_FEMETURE" 
	[title]="'Accès En attente de fermeture'" (accesActionRequest)="onActionRequest($event)" [restrictActionsToCacCc]="true"></acces-liste>

<acces-liste [refreshCommands]="reloadAccesTerminesCommands" [user]="user" 
	(accesClicked)="onAccesClicked($event)" [title]="'Accès Terminé'" (accesActionRequest)="onActionRequest($event)" [etat]="accesEtat.FERME" >
</acces-liste>

<acces-liste [refreshCommands]="reloadAccesRefusesCommands" [user]="user" [etat]="accesEtat.REFUSE" 
	(accesClicked)="onAccesClicked($event)" [title]="'Accès Refusé'" (accesActionRequest)="onActionRequest($event)">
</acces-liste>

<acces-liste [refreshCommands]="reloadAccesEnErreurCommands" [user]="user" [etat]="accesEtat.ERREUR"
	(accesClicked)="onAccesClicked($event)" [title]="'Accès en erreur / annulé'" (accesActionRequest)="onActionRequest($event)">
</acces-liste>

<div class="navbar">
	<button type="button" class="btn btn-primary" (click)="toutExporter()">Tout exporter</button>
</div>

<!-- affichage du détail de l'acces -->
<acces-details [displayCommands]="displayAccesDetailsSubject" (notificationRequested)="notify($event)"></acces-details>

<!-- popup de fermeture acces -->
<acces-fermeture [displayCommands]="displayAccesFermetureCommands" 
	(closedAccesSaved)="onAfterFermetureAcces($event[0], $event[1])" >
</acces-fermeture>

<controle-securite-dialog
    [displayCommands]="displayControleSecuriteCommands"
    (autorisationRequested)="onControleSecuriteAutorisation($event)">
</controle-securite-dialog>

<!-- popup de coactivite solaire -->
<coactivite-solaire-checker
	[id]="'coactiviteSolCheckerDialogFromListe'"
	[checkCommands]="checkCoactiviteSolaireCommands"
	(decisionIssued)="onCoactiviteDecision($event[0], $event[1], $event[2])"
	>
</coactivite-solaire-checker>

<!-- popup de coactivite eolien -->
<coactivite-eolien-checker
	[id]="'coactiviteEolCheckerDialogFromListe'"
	[checkCommands]="checkCoactiviteEolienCommands"
	(decisionIssued)="onCoactiviteDecision($event[0], $event[1], $event[2])"
	>
</coactivite-eolien-checker>

<!-- popup d'association arrêts -->
<acces-association-arrets-dialog
	[displayCommands]="displayAssociationArretsCommands"
	(associationArretsSaved)="onCompletingAssociationArrets($event)"
	>
</acces-association-arrets-dialog>

<modification-tarif-negatif [displayCommands]="modificationTarifNegatifCallSubject$"></modification-tarif-negatif>

<acces-refus [displayCommands]="displayRefusAccesCommands" (decisionIssued)="onCompletingRefus($event[0], $event[1])"></acces-refus>

<rappel-intervenants
	[displayCommands]="displayRappelIntervenantsCommands"
	(rappelChanged)="onRappelIntervenantsChanged()"
	>
</rappel-intervenants>
